import { requestJson } from "./apiClient";

const PUBLIC_BASE = "/api/client-views";
const ADMIN_BASE = "/api/admin/client-views";

export async function fetchClientViewTransportConfig(clientViewKey, options = {}) {
  if (!clientViewKey) {
    return null;
  }
  return requestJson(`${PUBLIC_BASE}/${encodeURIComponent(clientViewKey)}/transport/config`, {
    signal: options.signal,
  });
}

export async function fetchClientViewTransportSummary(clientViewKey, options = {}) {
  return requestJson(`${PUBLIC_BASE}/${encodeURIComponent(clientViewKey)}/transport/summary`, {
    signal: options.signal,
  });
}

export async function fetchClientViewTransportFeatures(clientViewKey, params = {}, options = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") {
      search.set(key, String(value));
    }
  });
  const qs = search.toString();
  return requestJson(
    `${PUBLIC_BASE}/${encodeURIComponent(clientViewKey)}/transport/features${qs ? `?${qs}` : ""}`,
    { signal: options.signal }
  );
}

export async function fetchAdminClientViewTransportConfig(clientViewId, options = {}) {
  return requestJson(`${ADMIN_BASE}/${encodeURIComponent(clientViewId)}/transport/config`, {
    signal: options.signal,
  });
}

export async function updateAdminClientViewTransportConfig(clientViewId, payload, options = {}) {
  return requestJson(`${ADMIN_BASE}/${encodeURIComponent(clientViewId)}/transport/config`, {
    method: "PATCH",
    body: payload,
    signal: options.signal,
  });
}

export async function resetAdminClientViewTransportConfig(clientViewId, options = {}) {
  return requestJson(`${ADMIN_BASE}/${encodeURIComponent(clientViewId)}/transport/config/reset`, {
    method: "POST",
    signal: options.signal,
  });
}

export async function validateAdminClientViewTransportConfig(
  clientViewId,
  payload = null,
  options = {}
) {
  return requestJson(`${ADMIN_BASE}/${encodeURIComponent(clientViewId)}/transport/config/validate`, {
    method: "POST",
    body: payload || {},
    signal: options.signal,
  });
}
